// extracted by mini-css-extract-plugin
module.exports = {"productHeading":"ItemHeading_productHeading__2u4Kx","openSans":"ItemHeading_openSans__2qAIu"};